<script setup>
import {
  PanelLeftCloseIcon,
  PanelRightCloseIcon,
} from '@hugeicons/core-free-icons';
import HugeIcon from 'dashboard/components-next/icon/HugeIcon.vue';

defineProps({
  collapsed: { type: Boolean, default: false },
});

const emit = defineEmits(['toggle']);
</script>

<template>
  <button
    type="button"
    class="flex size-7 shrink-0 items-center justify-center rounded-md text-n-slate-11 transition-colors hover:bg-n-alpha-2 hover:text-n-slate-12 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-n-brand"
    :aria-label="
      collapsed
        ? $t('CONTACTS_LAYOUT.SIDEBAR_NAV.EXPAND')
        : $t('CONTACTS_LAYOUT.SIDEBAR_NAV.COLLAPSE')
    "
    @click="emit('toggle')"
  >
    <HugeIcon
      :icon="collapsed ? PanelRightCloseIcon : PanelLeftCloseIcon"
      :size="20"
      class="size-5 shrink-0"
      aria-hidden="true"
    />
  </button>
</template>
